<template>
    <div :class="$style.container"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"
    >


        <el-container>

            <el-aside width="380px">
                <segment ref="segment" @sendMessage="sendMessage"></segment>

            </el-aside>
            <el-main width="100%" v-show="info">
                <div style="margin-top: 15px">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '/serviceSheet' }">服务工单</el-breadcrumb-item>
                        <el-breadcrumb-item><span style="color: dodgerblue">工单详情</span></el-breadcrumb-item>
                    </el-breadcrumb>


                    <el-row :gutter="24" style="margin-top: 20px">
                        <el-col :span="12">
                            <div align="left">
                                <span style="  border-radius: 4px; color: white; background-color: dodgerblue; padding: 5px; ">{{obj.account_name}}</span>
                                <span style=" margin-left: 5px; color: dodgerblue; padding: 5px; ">{{obj.store_name}}</span>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div style=" height: 60px; margin-top: -30px;">


                                <div style="display: flex; justify-content: flex-end;" align="right">
                                    <div v-if="checkType1 == true"
                                         style="width:80px; font-size: 10px; height: 20px; color:limegreen;"
                                         align="center">已派单
                                    </div>
                                    <div v-else="checkType1 == false"
                                         style="width:80px; font-size: 10px; height: 20px; color:lightgray;"
                                         align="center">已派单
                                    </div>

                                    <div v-if="checkType2 == true"
                                         style="width:80px; font-size: 10px; height: 20px; color:limegreen;"
                                         align="center">已接单
                                    </div>
                                    <div v-else="checkType2 == false"
                                         style="width:80px; font-size: 10px; height: 20px; color:lightgray;"
                                         align="center">已接单
                                    </div>

                                    <div v-if="checkType3 == true"
                                         style="width:80px; font-size: 10px; height: 20px; color:limegreen;"
                                         align="center">进行中
                                    </div>
                                    <div v-else="checkType3 == false"
                                         style="width:80px; font-size: 10px; height: 20px; color:lightgray;"
                                         align="center">进行中
                                    </div>

                                    <div v-if="checkType4 == true"
                                         style="width:80px; font-size: 10px; height: 20px; color:limegreen;"
                                         align="center">已评价
                                    </div>
                                    <div v-else="checkType4 == false"
                                         style="width:80px; font-size: 10px; height: 20px; color:lightgray;"
                                         align="center">已评价
                                    </div>

                                    <div v-if="checkType5 == true"
                                         style="width:80px; font-size: 10px; height: 20px; color:limegreen;"
                                         align="center">已完成
                                    </div>
                                    <div v-else="checkType5 == false"
                                         style="width:80px; font-size: 10px; height: 20px; color:lightgray;"
                                         align="center">已完成
                                    </div>
                                </div>


                                <div style="display: flex; justify-content: flex-end; margin-right: 30px" align="right">
                                    <div v-if="checkType1 == true"
                                         style="border-radius: 10px; height: 20px; width: 20px;background-color:limegreen "></div>
                                    <div v-else-if="checkType1 == false"
                                         style="border-radius: 10px; height: 20px; width: 20px;background-color:lightgray "></div>

                                    <div v-if="checkType1 == true"
                                         style="width:60px; height: 20px; overflow:hidden;" align="center">
                                        <div style="width:60px; margin-top: 8px; height: 3px; background-color:limegreen;overflow:hidden;"></div>
                                    </div>
                                    <div v-else-if="checkType1 == false"
                                         style="width:60px; height: 20px; overflow:hidden;" align="center">
                                        <div style="width:60px;  margin-top: 8px; height: 3px; background-color:lightgray;overflow:hidden;"></div>
                                    </div>


                                    <div v-if="checkType2 == true"
                                         style="border-radius: 10px; height: 20px; width: 20px;background-color:limegreen"></div>
                                    <div v-else-if="checkType2 == false"
                                         style="border-radius: 10px; height: 20px; width: 20px;background-color:lightgray"></div>

                                    <div v-if="checkType2 == true"
                                         style="width:60px; height: 20px; overflow:hidden;" align="center">
                                        <div style="width:60px;  margin-top: 8px; height: 3px; background-color:limegreen;overflow:hidden;"></div>
                                    </div>
                                    <div v-else-if="checkType2 == false"
                                         style="width:60px; height: 20px; overflow:hidden;" align="center">
                                        <div style="width:60px;  margin-top: 8px; height: 3px; background-color:lightgray;overflow:hidden;"></div>
                                    </div>


                                    <div v-if="checkType3 == true"
                                         style="border-radius: 10px; height: 20px; width: 20px;background-color:limegreen"></div>
                                    <div v-else-if="checkType3 == false"
                                         style="border-radius: 10px; height: 20px; width: 20px;background-color:lightgray"></div>

                                    <div v-if="checkType3 == true"
                                         style="width:60px; height: 20px; overflow:hidden;" align="center">
                                        <div style="width:60px;  margin-top: 8px; height: 3px; background-color:limegreen;overflow:hidden;"></div>
                                    </div>

                                    <div v-else-if="checkType3 == false"
                                         style="width:60px; height: 20px; overflow:hidden;" align="center">
                                        <div style="width:60px;  margin-top: 8px; height: 3px; background-color:lightgray;overflow:hidden;"></div>
                                    </div>

                                    <div v-if="checkType4 == true"
                                         style="border-radius: 10px; height: 20px; width: 20px;background-color:limegreen "></div>
                                    <div v-else-if="checkType4 == false"
                                         style="border-radius: 10px; height: 20px; width: 20px;background-color:lightgray "></div>


                                    <div v-if="checkType4 == true"
                                         style="width:60px; height: 20px; overflow:hidden;" align="center">
                                        <div style="width:60px;  margin-top: 8px; height: 3px; background-color:limegreen;overflow:hidden;"></div>
                                    </div>

                                    <div v-else-if="checkType4 == false"
                                         style="width:60px; height: 20px; overflow:hidden;" align="center">
                                        <div style="width:60px;  margin-top: 8px; height: 3px; background-color:lightgray;overflow:hidden;"></div>
                                    </div>

                                    <div v-if="checkType5 == true"
                                         style="border-radius: 10px; height: 20px; width: 20px;background-color:limegreen "></div>
                                    <div v-else-if="checkType5 == false"
                                         style="border-radius: 10px; height: 20px; width: 20px;background-color:lightgray "></div>

                                </div>


                                <div style="display: flex; justify-content: flex-end; margin-top: 8px" align="right">
                                    <div v-if="checkType1 == true"
                                         style="width:80px; font-size: 10px; height: 20px; color:limegreen;"
                                         align="center">{{time1}}
                                    </div>
                                    <div v-else="checkType1 == false"
                                         style="width:80px; font-size: 10px; height: 20px; color:lightgray;"
                                         align="center">尚未完成
                                    </div>

                                    <div v-if="checkType2 == true"
                                         style="width:80px; font-size: 10px; height: 20px; color:limegreen;"
                                         align="center">{{time2}}
                                    </div>
                                    <div v-else="checkType2 == false"
                                         style="width:80px; font-size: 10px; height: 20px; color:lightgray;"
                                         align="center">尚未完成
                                    </div>

                                    <div v-if="checkType3 == true"
                                         style="width:80px; font-size: 10px; height: 20px; color:limegreen;"
                                         align="center">{{time3}}
                                    </div>
                                    <div v-else="checkType3 == false"
                                         style="width:80px; font-size: 10px; height: 20px; color:lightgray;"
                                         align="center">尚未完成
                                    </div>

                                    <div v-if="checkType4 == true"
                                         style="width:80px; font-size: 10px; height: 20px; color:limegreen;"
                                         align="center">{{time4}}
                                    </div>
                                    <div v-else="checkType4 == false"
                                         style="width:80px; font-size: 10px; height: 20px; color:lightgray;"
                                         align="center">尚未完成
                                    </div>

                                    <div v-if="checkType5 == true"
                                         style="width:80px; font-size: 10px; height: 20px; color:limegreen;"
                                         align="center">{{time5}}
                                    </div>
                                    <div v-else="checkType5 == false"
                                         style="width:80px; font-size: 10px; height: 20px; color:lightgray;"
                                         align="center">尚未完成
                                    </div>
                                </div>
                                <!--<div class="t-ctn" align="right" style="margin-top: 5px">-->
                                <!--<div class="s-ctn">-->

                                <!---->
                                <!--</div>-->
                                <!--</div>-->


                            </div>
                        </el-col>
                    </el-row>

                    <el-row :gutter="24" style="margin-top: 10px">
                        <el-col :span="7">
                            <div align="left">
                                <span style=" color: orange; padding: 5px; font-size: 12px">服务单号</span>
                                <span style=" color: slategrey; padding: 5px;  font-size: 12px">{{obj.ticket_no}}</span>
                            </div>
                            <div align="left" style="margin-top: 10px">
                                <span style=" color: orange; padding: 5px;  font-size: 12px">服务人员</span>
                                <span style=" color: slategrey; padding: 5px;  font-size: 12px">{{obj.alias + ' ' + obj.phone}}</span>
                            </div>
                        </el-col>
                        <el-col :span="17">
                            <div align="right">
                                <el-row>
                                    <el-button v-if="obj.reference_obj !== 'CLERK' && obj.status === 'AWAIT'"
                                               size="mini" type="warning"
                                               @click.stop="openApprovePlaceOrder">审批下单
                                    </el-button>

                                    <!--<el-button v-else-if="pushForm.user_id != ''" size="mini" type="primary"-->
                                    <!--@click.stop="showPushForm">更换服务人员-->
                                    <!--</el-button>-->

                                    <el-button size="mini" type="danger"
                                               v-if="(obj.receipt_status == 'REPORT_UNCONFIRMED'
                                               && obj.status !== 'CLOSED'
                                               && obj.status !== 'SERVICE_REFUSED')
                                               && (obj.reference_obj !== 'CLERK'
                                               || obj.manager == 'T')"
                                               @click="refusedTicket">拒绝此工单
                                    </el-button>
                                    <el-button size="mini" type="success"
                                               v-if="(obj.receipt_status == 'REPORT_UNCONFIRMED'
                                               && obj.status !== 'CLOSED'
                                               && obj.status !== 'SERVICE_REFUSED')
                                               && (obj.reference_obj !== 'CLERK'
                                               || obj.manager == 'T')"
                                               @click="completedTicket">完成此工单
                                    </el-button>

                                    <!--<el-button size="mini" type="danger" @click="closeTicket">关闭此工单</el-button>-->

                                    <!--&& this.obj.initiator != 'RETAIL'-->
                                    <el-button size="mini"
                                               v-show="activeName === 'first'"
                                               type="primary"
                                               @click="saveFirst">保存
                                    </el-button>
                                    <!--<el-button size="mini" v-show="activeName === 'second' && pushForm.user_id != ''"-->
                                    <!--type="primary"-->
                                    <!--@click="saveSecond">保存-->
                                    <!--</el-button>-->
                                    <!--<el-button size="mini" v-show="activeName === 'third' && pushForm.user_id != '' "-->
                                    <!--type="primary"-->
                                    <!--@click="saveThird">保存-->
                                    <!--</el-button>-->
                                    <el-button size="mini" v-show="obj.status === 'AWAIT' && activeName === 'fourth'"
                                               type="primary"
                                               @click="saveFoutrh">保存
                                    </el-button>
                                    <!--<el-button size="mini" v-show="activeName === 'fifth' && pushForm.user_id != ''" type="primary"-->
                                    <!--@click="back()">保存-->
                                    <!--</el-button>-->
                                    <el-button size="mini" type="danger" @click="back()">
                                        <img :src="backArrow" width="12px" style="margin-right: 5px;">
                                        返回
                                    </el-button>
                                </el-row>
                            </div>
                        </el-col>
                    </el-row>


                    <div style="width: 100%; height: 0px; margin-top: 10px;border:1px dashed gainsboro"></div>

                    <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-top: 10px">
                        <el-tab-pane label="报修情况" name="first"></el-tab-pane>
                        <el-tab-pane label="工单概览" name="second"></el-tab-pane>
                        <!--<el-tab-pane label="服务清单" name="third"></el-tab-pane>-->
                        <el-tab-pane label="完工单" name="fourth"></el-tab-pane>
                        <el-tab-pane label="报价单" name="fifth"></el-tab-pane>
                    </el-tabs>

                </div>

                <div style="margin-top: 20px" v-show="activeName === 'first'">
                    <firstForm ref="firstForm" @showImageAction="showImageAction"></firstForm>
                </div>


                <div style="margin-top: 20px" v-show="activeName === 'second'">
                    <secondForm ref="secondForm"></secondForm>

                </div>

                <!--<div style="margin-top: 20px" v-show="activeName === 'third'">-->

                    <!--<thirdForm ref="thirdForm" @addproject="addproject" @showInfo="showInfo"-->
                               <!--@showImageAction="showImageAction"></thirdForm>-->
                    <!--<addThird ref="addThird" @addthirdFormItem="addthirdFormItem"></addThird>-->


                <!--</div>-->

                <div style="margin-top: 20px" v-show="activeName === 'fourth'">
                    <fourthForm ref="fourthForm" @showImageAction="showImageAction"></fourthForm>

                </div>

                <div style="margin-top: 20px; min-height: 400px" v-show="activeName === 'fifth'">
                    <fifthForm ref="fifthForm" @addPrice="addPrice" @showFifthInfo="showFifthInfo"></fifthForm>

                </div>

                <el-dialog
                        :visible.sync="pushForm.push"
                        width="600px"
                        height="75%"
                        :show-close="false"
                        :before-close="handleClose"
                        class="a_modal"
                        style="vertical-align: center;: #FFF9F3">
                    <div style="margin-top: -30px; ">

                        <el-row>
                            <el-col :span="12">
                                <span style="color: cornflowerblue; font-size: 18px">服务派单</span>
                            </el-col>
                            <el-col :span="12">
                                <div align="right" style="margin-top: -10px">
                                    <el-row>
                                        <el-button type="success" size="small"
                                                   @click.stop="enterPushForm">确定
                                        </el-button>
                                        <el-button type="danger" size="small"
                                                   @click.stop="closePushForm">取消
                                        </el-button>
                                    </el-row>
                                </div>
                            </el-col>
                        </el-row>

                        <div style="width: 100%; height: 0px; margin-top: 10px;border:1px dashed gainsboro"></div>

                        <div align="center" style="margin-top: 20px">


                            <el-button-group>
                                <el-button v-if="this.pushForm.radio === '自备人员' && ticketEmployee == true" plain
                                           style="background:orange; color: white; border-color: orange" size="mini"
                                           @click.stop="onClick10">自备人员
                                </el-button>
                                <el-button v-else-if="this.pushForm.radio !== '自备人员' && ticketEmployee == true" plain
                                           style="color: orange; background: white; border-color: orange"
                                           size="mini"
                                           @click.stop="onClick10">自备人员
                                </el-button>
                                <el-button v-if="this.pushForm.radio === '外包人员' && ticketOutsourcing == true" plain
                                           style="background: orange;color: white; border-color: orange" size="mini"
                                           @click.stop="onClick20">外包人员
                                </el-button>
                                <el-button v-else-if="this.pushForm.radio !== '外包人员' && ticketOutsourcing == true" plain
                                           style="color: orange; background: white; border-color: orange"
                                           size="mini"
                                           @click.stop="onClick20">外包人员
                                </el-button>
                            </el-button-group>
                        </div>


                        <!--dd vertical-->
                        <!--<el-scrollbar :class="$style.scrollbar" vertical>-->
                        <div style="margin-top: 10px" align="left" v-if="this.pushForm.radio === '自备人员'">
                            <div v-for="dataObj in pushForm.EMPLOYEE"
                                 style=" min-width: 160px; margin-top: 10px; border-radius: 2px; border: 1px solid gainsboro ">

                                <el-row :gutter="24" style="margin-top: 10px">
                                    <el-col :span="18">
                                        <div style=" margin-left: 5px; height: 140px">
                                            <el-row :gutter="24" style="margin-top: 5px; margin-left: 5px">
                                                <el-col :span="3">
                                                    <div style="margin-top: 15px">
                                                        <img width="40px" height="40px"
                                                             :src="chatHeader" alt="">
                                                    </div>
                                                    <div @click.stop="clickImage(dataObj.user_id)"
                                                         v-if="pushForm.tempUserId !== dataObj.user_id"
                                                         style="margin-top: 10px; margin-left: 5px">
                                                        <img width="25px" height="25px"
                                                             :src="grayYuan" alt="">
                                                    </div>
                                                    <div @click.stop="clickImage(dataObj.user_id)"
                                                         v-else-if="pushForm.tempUserId == dataObj.user_id"
                                                         style="margin-top: 10px; margin-left: 5px">
                                                        <img width="25px" height="25px"
                                                             :src="greengou" alt="">
                                                    </div>

                                                </el-col>
                                                <el-col :span="21" style="margin-top: 15px">
                                                    <div> {{dataObj.last_name}}  </div>
                                                    <div style="margin-top: 5px; color: lightgray">
                                                        <img
                                                                width="15px"
                                                                height="15px"
                                                                :src="phone"
                                                                alt="">
                                                        {{dataObj.phone}}
                                                    </div>
                                                    <div style="margin-top: 10px">
                                                               <span style="  font-size: 10px;  color: lightgray; ">
                                                              最近一次服务的门店
                                                          </span>
                                                    </div>

                                                    <div style="margin-top: 10px">
                                                          <span style="  padding: 2px; border-radius: 2px; font-size: 10px; background: cornflowerblue; color: white; ">
                                                              {{dataObj.account_name}}
                                                          </span>
                                                        <span style=" padding: 5px; font-size: 10px;  color: lightgray; ">
                                                              {{dataObj.store_name}}
                                                          </span>
                                                    </div>
                                                    <div style="margin-top: 10px; font-size: 14px; width: 100%; ">
                                                        {{dataObj.title}}
                                                    </div>

                                                </el-col>
                                            </el-row>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div style="margin-right: 10px; " align="center">
                                            <div>
                                                <el-row :gutter="24" style="margin-top: 5px">
                                                    <el-col :span="12">
                                                        <div style=" width: 45px; padding-top: 5px; padding-bottom: 5px;  font-size: 6px; color: lightgray; ">
                                                            未完成
                                                        </div>
                                                    </el-col>
                                                    <el-col :span="12">
                                                        <div style=" width: 50px; padding-top: 5px; padding-bottom: 5px;  font-size: 6px; color: lightgray; ">
                                                            完成服务
                                                        </div>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                            <div style="margin-top: 5px">
                                                <el-row :gutter="24">
                                                    <el-col :span="12">
                                                        <div style=" width: 45px; padding-top: 8px; padding-bottom: 8px; border-radius: 2px; font-size: 14px; background: red; color: white; ">
                                                            {{dataObj.incomplete}}
                                                        </div>
                                                    </el-col>
                                                    <el-col :span="12">
                                                        <div style=" width: 45px; padding-top: 8px; padding-bottom: 8px; border-radius: 2px; font-size: 14px; background: cornflowerblue; color: white;">
                                                            {{dataObj.complete}}
                                                        </div>
                                                    </el-col>
                                                </el-row>
                                            </div>

                                            <div style="margin-top: 5px">
                                                <el-row :gutter="24" style="margin-top: 10px">
                                                    <el-col :span="12">
                                                        <div style=" width: 45px; padding-top: 5px; padding-bottom: 5px;  font-size: 6px; color: lightgray; ">
                                                            接单率
                                                        </div>
                                                    </el-col>
                                                    <el-col :span="12">
                                                        <div style=" width: 50px; padding-top: 5px; padding-bottom: 5px;  font-size: 6px; color: lightgray; ">
                                                            五星好评
                                                        </div>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                            <div style="margin-top: 5px">
                                                <el-row :gutter="24">
                                                    <el-col :span="12">
                                                        <div style=" width: 45px; padding-top: 8px; padding-bottom: 8px; border-radius: 2px; font-size: 14px; background: orange; color: white; ">
                                                            {{dataObj.index * 100 + '%'}}
                                                        </div>
                                                    </el-col>
                                                    <el-col :span="12">
                                                        <div style=" width: 45px; padding-top: 8px; padding-bottom: 8px; border-radius: 2px; font-size: 14px; background: greenyellow; color: white;">
                                                            {{dataObj.feedback * 100 + '%'}}
                                                        </div>
                                                    </el-col>
                                                </el-row>
                                            </div>

                                        </div>
                                    </el-col>
                                </el-row>

                            </div>
                        </div>


                        <div style="margin-top: 10px" align="left" v-if="this.pushForm.radio === '外包人员'">
                            <div v-for="dataObj in pushForm.OUTSOURCING"
                                 style=" min-width: 160px; margin-top: 10px; border-radius: 2px; border: 1px solid gainsboro ">

                                <el-row :gutter="24" style="margin-top: 10px">
                                    <el-col :span="18">
                                        <div style=" margin-left: 5px; height: 140px">
                                            <el-row :gutter="24" style="margin-top: 5px; margin-left: 5px">
                                                <el-col :span="3">
                                                    <div style="margin-top: 15px">
                                                        <img width="40px" height="40px"
                                                             :src="chatHeader" alt="">
                                                    </div>
                                                    <div @click.stop="clickImage(dataObj.user_id)"
                                                         v-if="pushForm.tempUserId !== dataObj.user_id"
                                                         style="margin-top: 10px; margin-left: 5px">
                                                        <img width="25px" height="25px"
                                                             :src="grayYuan" alt="">
                                                    </div>
                                                    <div @click.stop="clickImage(dataObj.user_id)"
                                                         v-else-if="pushForm.tempUserId == dataObj.user_id"
                                                         style="margin-top: 10px; margin-left: 5px">
                                                        <img width="25px" height="25px"
                                                             :src="greengou" alt="">
                                                    </div>

                                                </el-col>
                                                <el-col :span="21" style="margin-top: 15px">
                                                    <div> {{dataObj.last_name}}  </div>
                                                    <div style="margin-top: 5px; color: lightgray"><img
                                                            width="15px"
                                                            height="15px"
                                                            :src="phone"
                                                            alt="">
                                                        {{dataObj.phone}}
                                                    </div>
                                                    <div style="margin-top: 10px">
                                                               <span style="  font-size: 10px;  color: lightgray; ">
                                                              最近一次服务的门店
                                                          </span>
                                                    </div>

                                                    <div style="margin-top: 10px">
                                                          <span style="  padding: 2px; border-radius: 2px; font-size: 10px; background: cornflowerblue; color: white; ">
                                                              {{dataObj.account_name}}
                                                          </span>
                                                        <span style=" padding: 5px; font-size: 10px;  color: lightgray; ">
                                                              {{dataObj.store_name}}
                                                          </span>
                                                    </div>
                                                    <div style="margin-top: 10px; font-size: 14px; width: 100%; ">
                                                        {{dataObj.title}}
                                                    </div>

                                                </el-col>
                                            </el-row>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div style="margin-right: 10px; " align="center">
                                            <div>
                                                <el-row :gutter="24" style="margin-top: 5px">
                                                    <el-col :span="12">
                                                        <div style=" width: 45px; padding-top: 5px; padding-bottom: 5px;  font-size: 6px; color: lightgray; ">
                                                            未完成
                                                        </div>
                                                    </el-col>
                                                    <el-col :span="12">
                                                        <div style=" width: 50px; padding-top: 5px; padding-bottom: 5px;  font-size: 6px; color: lightgray; ">
                                                            完成服务
                                                        </div>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                            <div style="margin-top: 5px">
                                                <el-row :gutter="24">
                                                    <el-col :span="12">
                                                        <div style=" width: 45px; padding-top: 8px; padding-bottom: 8px; border-radius: 2px; font-size: 14px; background: red; color: white; ">
                                                            {{dataObj.incomplete}}
                                                        </div>
                                                    </el-col>
                                                    <el-col :span="12">
                                                        <div style=" width: 45px; padding-top: 8px; padding-bottom: 8px; border-radius: 2px; font-size: 14px; background: cornflowerblue; color: white;">
                                                            {{dataObj.complete}}
                                                        </div>
                                                    </el-col>
                                                </el-row>
                                            </div>

                                            <div style="margin-top: 5px">
                                                <el-row :gutter="24" style="margin-top: 10px">
                                                    <el-col :span="12">
                                                        <div style=" width: 45px; padding-top: 5px; padding-bottom: 5px;  font-size: 6px; color: lightgray; ">
                                                            接单率
                                                        </div>
                                                    </el-col>
                                                    <el-col :span="12">
                                                        <div style=" width: 50px; padding-top: 5px; padding-bottom: 5px;  font-size: 6px; color: lightgray; ">
                                                            五星好评
                                                        </div>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                            <div style="margin-top: 5px">
                                                <el-row :gutter="24">
                                                    <el-col :span="12">
                                                        <div style=" width: 45px; padding-top: 8px; padding-bottom: 8px; border-radius: 2px; font-size: 14px; background: orange; color: white; ">
                                                            {{dataObj.index * 100 + '%'}}
                                                        </div>
                                                    </el-col>
                                                    <el-col :span="12">
                                                        <div style=" width: 45px; padding-top: 8px; padding-bottom: 8px; border-radius: 2px; font-size: 14px; background: greenyellow; color: white;">
                                                            {{dataObj.feedback * 100 + '%'}}
                                                        </div>
                                                    </el-col>
                                                </el-row>
                                            </div>

                                        </div>
                                    </el-col>
                                </el-row>

                            </div>
                        </div>

                    </div>

                </el-dialog>
                <el-dialog
                        title="提示"
                        :visible.sync="showCloseTicket"
                        width="30%"
                        :show-close="false"
                        :before-close="handleClose">
                    <span>确定关闭此工单?</span>
                    <span slot="footer" class="dialog-footer">
    <el-button @click="showCloseTicket = false">取 消</el-button>
    <el-button type="primary" @click="enterClose('CLOSED')">确 定</el-button>
  </span>
                </el-dialog>
                <el-dialog
                        title="提示"
                        :visible.sync="showCompletedTicket"
                        width="30%"
                        :show-close="false"
                        :before-close="handleClose">
                    <span>确定完成此工单?</span>
                    <span slot="footer" class="dialog-footer">
    <el-button @click="showCompletedTicket = false">取 消</el-button>
    <el-button type="primary" @click="enterClose('COMPLETED')">确 定</el-button>
  </span>
                </el-dialog>
                <el-dialog
                        title="提示"
                        :visible.sync="showServiceRefused"
                        width="30%"
                        :show-close="false"
                        :before-close="handleClose">
                    <span>确定拒绝此工单?</span>
                    <span slot="footer" class="dialog-footer">
    <el-button @click="showServiceRefused = false">取 消</el-button>
    <el-button type="primary" @click="enterClose('SERVICE_REFUSED')">确 定</el-button>
  </span>
                </el-dialog>


            </el-main>

            <el-main width="100%" v-show="info==false">
                <fifthInfo ref="fifthInfo" @backFifthForm="backFifthForm"></fifthInfo>
            </el-main>


            <addMessage ref="addMessage" @showImageAction="showImageAction" @saveMsg="saveMsg"></addMessage>
            <showImageDialog ref="showImageDialog"></showImageDialog>

        </el-container>


    </div>


</template>

<script>

    import segment from './segment/segment.vue'

    import http from '../../APIService/http'
    import backArrow from '../../assets/images/back-arrow.png'
    import grayFullYuan from '../../assets/images/gray-full-yuan.png'
    import grayYuan from '../../assets/images/gray-yuan.png'
    import file from '../../assets/images/file.png'
    import time from '../../assets/images/time.png'
    import phone from '../../assets/images/phone.png'
    import chatHeader from '../../assets/images/chat_header_image.png'
    import greengou from '../../assets/images/green-gou.png'
    import moment from 'moment'

    import showImageDialog from './dialog/showImageDialog.vue'
    import addThird from './dialog/addThird.vue'
    import addMessage from './dialog/addMessage.vue'

    import firstForm from './form/firstForm.vue'
    import secondForm from './form/secondForm.vue'
    import thirdForm from './form/thirdForm.vue'
    import fourthForm from './form/fourthForm.vue'
    import fifthForm from './form/fifthForm.vue'
    import fifthInfo from './form/fifthInfo.vue'


    export default {
        data() {
            return {
                loading: false,
                obj: {
//                    initiator: "RETAIL"
                    initiator: "SERVICE",
                    created_by: "",
                    account_name: "",
                    store_name: "",
                    alias: "",
                    ticket_id: '',
                    ticket_no: "",
                    phone: "",
                    photo: [],
                    status: "NEW",
                    stepDatas: [{title: "已接单"},
                        {title: "已派单"},
                        {title: "进行中"},
                        {title: "已完工"},
                        {title: "已评价"}],
                    reference_obj: '',
                    manager: '',
                    receipt_status: ''
                },


                pushForm: {
                    push: false,
                    radio: '自备人员',
                    EMPLOYEE: [],
                    OUTSOURCING: [],
                    user_id: '',
                    tempUserId: ''
                },
                type: 1,

//--------------------------------------------------


                time1: "",
                time2: "",
                time3: "",
                time4: "",
                time5: "",

                left: 'left',
                //创建工单
                createTicket: false,
                //派给自备
                ticketEmployee: false,
                //派给外包
                ticketOutsourcing: false,


                moment: moment,
                showCloseTicket: false,
                showCompletedTicket: false,
                showServiceRefused: false,
                time: time,
                greengou: greengou,
                chatHeader: chatHeader,
                grayYuan: grayYuan,
                grayFullYuan: grayFullYuan,
                backArrow: backArrow,
                file: file,
                phone: phone,
                selfUser_id: "",

                info: true,

                activeName: 'first',
                active: 1,


                thirdForm: {
                    create_by: '',
                    create_name: '',
                    tenant_name: '',
                    alias: '',
                    date: '',
                    type: "SHOW",
                    dialogVisible: false,
                    service_comments: "",
                    item: [],
                    photos: [],
                    fileList: [],

                },

                fifthForm: {
                    tableData: []
                },

                form3: {
                    service_item: '',
                    number: '',
                    comments: '',
                },

                form4: {
                    quotation_name: '',
                    quotation_number: '',
                    quotation_amount: '',
                    quotation_item: '',
                    info: false,

                },


                formInfo: {
                    quotation_status: '',
                    created_by: '',
                    created_date: '',
                    quotation_id: '',
                    effective_date: '',
                    sumamount: '',
                    tenant_name: '',
                    create_name: '',
                    info: false,
                    title: '',
                    date: '',
                    tableData: []
                },


            }
        },
        components: {
            segment,
            showImageDialog,
            firstForm,
            secondForm,
            addThird,
            thirdForm,
            fourthForm,
            fifthForm,
            fifthInfo,
            addMessage
        },
        computed: {

            checkType1() {

                if (this.time1 != null && this.time1 != "") {
                    return true
                }
                else {
                    return false
                }
            },
            checkType2() {
                if (this.time2 != null && this.time2 != "") {
                    return true
                }
                else {
                    return false
                }
            },
            checkType3() {
                if (this.time3 != null && this.time3 != "") {
                    return true
                }
                else {
                    return false
                }
            },
            checkType4() {
                if (this.time4 != null && this.time4 != "") {
                    return true
                }
                else {
                    return false
                }
            },
            checkType5() {
                if (this.time5 != null && this.time5 != "") {
                    return true
                }
                else {
                    return false
                }
            },
        },
        created() {


            this.activeName = this.$store.getters.getRadio2.radio
            if (this.activeName == ''){
                this.activeName = 'first'
            }

            debugger
            let a  = this.$route.params.row;

//            var user = this.$store.getters.getUser
//            this.selfUser_id = user.user_id
            var ticket_id = this.$route.query.ticket_id
            this.obj.ticket_id = ticket_id
//            var store_name = this.$route.query.store_name
//            this.type = this.$route.query.type
//            var address = this.$route.query.address
//            this.$refs.secondForm.setLabelContent( store_name + '</br>' + address)
//            this.init(true)
//            this.getRoles()
//            this.getServiceList()
            this.getUsersData()

            this.init(true)
//            this.getTicketPs('RETAIL')
            this.getTicketPs('SERVICE')

        },
        methods: {
            openLoading() {
                this.loading = true
            },
            closeLoading() {
                this.loading = false
            },
            sendMessage(data) {
                this.$refs.addMessage.getInfo(data)
            },
            async saveMsg(showMsgForm) {

//                if (this.showMsgForm.msg.replace(/\s*/g, "") == "") {
//                    this.$message.error('请输入内容');
//                    return
//                }
                this.loading = true
                var user = this.$store.getters.getUser
                try {
                    var photo = ""

                    if (showMsgForm.photos.length > 0) {
                        for (var i = 0; i < showMsgForm.photos.length; i++) {
                            var obj = showMsgForm.photos[i]
                            if (i == 0) {
                                photo = photo + "\"" + obj.file_id + "\"";
                            } else {
                                photo = photo + ",\"" + obj.file_id + "\"";
                            }
                        }
                    }

                    var paramStr = "client_id=" + user.client_id
                        + "&client_secret=" + "58f09f86-694c-472d-bb63-64f9be093fd2"//user.client_secret
                        + "&service_id=" + "r365_server" //user.service_id
                        + "&username=" + user.username
                        + "&tenant_id=" + user.tenant_id
                        + "&token=" + user.token
                        + "&data={"
                        + "\"tenant_id\":\"" + user.tenant_id + "\","
                        + "\"ticket_id\":\"" + this.obj.ticket_id + "\","
                        + "\"contents\":{"
                        + "\"comments\":\"" + showMsgForm.msg + "\","
                        + "\"photos\":[" + photo + "] "
                        + "},"
                        + "\"worker_id\":\"" + this.pushForm.user_id + "\","
                        + "\"type\":\"" + showMsgForm.type + "\","
                        + "\"created_by\":\"" + user.user_id + "\","
                        + "\"user_id\":\"" + user.user_id + "\"}"

                    let res = await http.post('https://api.concierge24x7.cn:16080/wapi/order/saveTicket_ps', paramStr)
                    if (res.success) {
                        showMsgForm.showMsg = false

                        var obj = {}
                        obj.alias = user.alias
                        obj.msg = showMsgForm.msg
                        obj.time = new Date().Format('yyyy-MM-dd hh:mm:ss')
                        obj.photos = []
                        if (showMsgForm.photos.length > 0) {
                            for (var i = 0; i < showMsgForm.photos.length; i++) {
                                var file = showMsgForm.photos[i]
                                this.getImgUrl(obj.photos, file.file_id)
                            }
                        }

                        if (showMsgForm.type == 'RETAIL') {
                            this.$refs.segment.addRetailDatas(obj)
                        } else {
                            this.$refs.segment.addServiceDatas(obj)
                        }

                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });

                    }
                    else {
                        this.$message.error(res.message);
                    }
                        this.loading = false
                }
                catch (err) {
                    this.error()
                }
            },
            //门店 服务人员列表
            async getTicketPs(type) {

//                this.loading = true
                var user = this.$store.getters.getUser
                try {
                    var data = {
                        tenant_id: user.tenant_id,
                        ticket_id: this.obj.ticket_id,
                        type: type
                    }

                    await http.post('/wapi/v1/getTicketPs', data).then(res => {
                        var array = []
                        if (res.success) {

                            for (var i = 0; i < res.data.length; i++) {
                                var dic = res.data[i]
                                var obj = {}
                                obj.alias = dic.alias
                                obj.msg = dic.contents.comments
                                obj.time = new Date(dic.timestamp).Format('yyyy-MM-dd hh:mm:ss')
                                obj.photos = []
                                for (var j = 0; j < dic.contents.photos.length; j++) {
                                    var id = dic.contents.photos[j]
                                    this.getImgUrl(obj.photos, id)
                                }

                                if (type == 'RETAIL') {
                                    array.push(obj)
                                } else {
                                    array.push(obj)
                                }
                            }
                        }
                        else {
                            this.$message.error(res.message);
                        }

                        if (type == 'RETAIL') {
                            this.$refs.segment.setRetailDatas(array)
                        } else {
                            this.$refs.segment.setServiceDatas(array)
                        }
                    })
                }
                catch (err) {
                    this.error()
                }
            },
            //获取图片地址
            async getImgUrl(array, file_id) {
                try {

                    var user = this.$store.getters.getUser


                    var data = new FormData(); //创建form对象
                    data.append('credential', user.client_secret);
                    data.append('photo_ids', file_id);
                    data.append('reference_id', user.reference_id);
                    data.append('reference_obj', user.reference_obj);
                    data.append('tenant_id', user.tenant_id);

                    let res = await http.post('https://api.retailstore365.com:15041/downloadphotos', data)

                    if (res.success == true) {
                        array.push({url: res.data[0].url, uid: res.data[0].photoid})

                    }

                } catch (err) {
                    console.log(`error:${err}`)
                }
            },
            //显示大图
            showImageAction(data) {

                this.$refs.showImageDialog.show(data.showImageUrl)
            },

            async init(reloadPhoto) {
                this.loading = true

                var ticket_id = this.obj.ticket_id
                var obj = this.$store.getters.getUser

                try {
                    let data = {
                        user_id: obj.user_id,
                        tenant_id: obj.tenant_id,
                        ticket_id: ticket_id
                    }
                    let res = await http.post('/wapi/v1/getOrderInfo', data)

                    if (res.success) {

                        if (res.data.order && res.data.order.length > 0) {
                            var order = res.data.order[0]
                            this.obj.alias = order.alias == null ? '' : order.alias
                            this.obj.ticket_no = order.ticket_no
                            this.obj.store_name = order.store_name
                            this.obj.phone = order.phone == null ? '' : order.phone
                            this.obj.account_name = order.account_name
                            this.obj.photos = order.contents.photos
                            this.obj.status = order.status
                            this.obj.ticket_id = order.ticket_id
                            this.obj.created_by = order.created_by
                            this.obj.initiator = order.initiator
                            this.obj.reference_obj = res.data.reference_obj
                            this.obj.manager = res.data.manager
                            this.obj.receipt_status = ''

                            this.$refs.firstForm.getObj(this.obj)
                            this.$refs.secondForm.getObj(this.obj)
                            this.$refs.thirdForm.getObj(this.obj)
                            this.$refs.fourthForm.getObj(this.obj)
                            this.$refs.fifthForm.getObj(this.obj)
                            this.$refs.fifthInfo.getObj(this.obj)


                            var service_timeline = order.service_timeline
                            var time = service_timeline.time == null ? [] : service_timeline.time
                            var text = service_timeline.text == null ? [] : service_timeline.text
                            var stepDatas = []


                            if (time.length == text.length) {
                                for (var i = time.length - 1; i > -1; i--) {
                                    var timeStr = time[i]
                                    var textStr = text[i]
                                    var obj = {}
                                    obj.timestamp = timeStr
                                    obj.content = textStr
                                    stepDatas.push(obj)
                                    //已派单
                                    if ((textStr.includes("在线报修单已提交") || textStr.includes("已派单")) && this.time1 === '') {
                                        this.time1 = new Date(obj.timestamp).Format('yyyy-MM-dd')
                                    }
                                    //已接单
                                    if (textStr.includes("已接单") && this.time2 === '') {
                                        this.time2 = new Date(obj.timestamp).Format('yyyy-MM-dd')

                                    }
                                    //进行中
                                    if ((textStr.includes("客服已关闭此工单") ||
                                            textStr.includes("服务清单") ||
                                            textStr.includes("完工单") ||
                                            textStr.includes("报价单")) && this.time3 === '') {
                                        this.time3 = new Date(obj.timestamp).Format('yyyy-MM-dd')

                                    }
                                    //完成工单
                                    if (textStr.includes("客服已完成此工单") && this.time4 === '') {
                                        this.time5 = new Date(obj.timestamp).Format('yyyy-MM-dd')
                                    }
                                }
                            }
                            this.$refs.segment.setStepDatas(stepDatas)


                            var fourthForm = {}

                            fourthForm.alias = order.alias
                            fourthForm.tenant_name = order.tenant_name
                            fourthForm.create_name = order.create_name
                            fourthForm.create_by = order.created_by == null ? '' : order.create_by
                            fourthForm.date = order.create_date == null ? new Date().Format('YYYY-MM-DDTHH:mm:ss.SSSZ') : order.create_date //moment(new Date()).format("yyyy-MM-dd")

                            if (order.service_receipt) {
                                fourthForm.serviceComments = order.service_receipt.serviceComments

                                if (reloadPhoto == true) {
                                    fourthForm.back_photos = []
                                    fourthForm.backFileList = []
                                    if (order.service_receipt.back_photos) {

                                        for (var i = 0; i < order.service_receipt.back_photos.length; i++) {
                                            var uid = order.service_receipt.back_photos[i]
                                            var file_id = order.service_receipt.back_photos[i]
                                            var obj = {uid: uid, file_id: file_id}
                                            fourthForm.back_photos.push(obj)
                                            this.getImgUrl(fourthForm.backFileList, order.service_receipt.back_photos[i])
                                        }
                                    }
                                    fourthForm.before_photos = []
                                    fourthForm.beforeFileList = []
                                    if (order.service_receipt.before_photos) {
                                        for (var i = 0; i < order.service_receipt.before_photos.length; i++) {
                                            var uid = order.service_receipt.before_photos[i]
                                            var file_id = order.service_receipt.before_photos[i]
                                            var obj = {uid: uid, file_id: file_id}
                                            fourthForm.before_photos.push(obj)
                                            this.getImgUrl(fourthForm.beforeFileList, order.service_receipt.before_photos[i])
                                        }
                                    }


                                    fourthForm.store_service_photos = []
                                    fourthForm.storeServiceFileList = []
                                    if (order.service_receipt.store_service_photos) {
                                        for (var i = 0; i < order.service_receipt.store_service_photos.length; i++) {
                                            var uid = order.service_receipt.store_service_photos[i]
                                            var file_id = order.service_receipt.store_service_photos[i]
                                            var obj = {uid: uid, file_id: file_id}
                                            fourthForm.store_service_photos.push(obj)
                                            this.getImgUrl(fourthForm.storeServiceFileList, order.service_receipt.store_service_photos[i])
                                        }
                                    }
                                }
                                fourthForm.completion_date = order.service_receipt.completion_date
                                fourthForm.service_content = order.service_receipt.service_content
                                fourthForm.service_describe = order.service_receipt.service_describe
                                fourthForm.store_service_content = order.service_receipt.store_service_content
                                fourthForm.store_service_stars = order.service_receipt.store_service_stars
                                fourthForm.date = order.service_receipt.created_date
                                fourthForm.create_by = order.service_receipt.created_by
                                fourthForm.created_tenant_id = order.service_receipt.created_tenant_id
                                fourthForm.receipt_status = order.service_receipt.receipt_status
                                this.obj.receipt_status = order.service_receipt.receipt_status
                                //已评价
                                if (fourthForm.store_service_content != '') {
                                    this.time4 = new Date(fourthForm.date).Format('yyyy-MM-dd')

                                }
                                this.$refs.secondForm.setCompletedDate(order.service_receipt.completion_date)
                            }
                            this.$refs.fourthForm.setInfo(fourthForm)


                            //third

                            var thirdForm = {}
                            thirdForm.alias = order.alias
                            thirdForm.tenant_name = order.tenant_name
                            thirdForm.create_name = order.create_name
                            thirdForm.create_by = ''
                            thirdForm.date = new Date().Format('yyyy-MM-dd') // moment(new Date()).format("yyyy-MM-dd")

                            if (order.service_list) {
                                thirdForm.date = order.service_list.date
                                thirdForm.service_comments = order.service_list.service_comments
                                thirdForm.item = order.service_list.item
                                thirdForm.create_by = order.service_list.create_by
                                if (reloadPhoto == true) {


                                    thirdForm.photos = []
                                    thirdForm.fileList = []
                                    for (var i = 0; i < order.service_list.photos.length; i++) {
                                        var uid = order.service_list.photos[i]
                                        var file_id = order.service_list.photos[i]
                                        var obj = {uid: uid, file_id: file_id}
                                        thirdForm.photos.push(obj)
                                        this.getImgUrl(thirdForm.fileList, order.service_list.photos[i])
                                    }
                                }
                            }
                            this.$refs.thirdForm.setInfo(thirdForm)


                            //second

                            var secondForm = {}
                            secondForm.date = order.contents.date
                            secondForm.dispatch_date = order.dispatch_date
                            secondForm.center = [parseFloat(order.lng), parseFloat(order.lat)]
                            secondForm.lng = parseFloat(order.lng)
                            secondForm.lat = parseFloat(order.lat)
                            secondForm.zoom = 14
                            secondForm.position = [parseFloat(order.lng), parseFloat(order.lat)]
                            secondForm.content = order.store_name + "</br>" + order.address
                            secondForm.comments = order.comments
                            secondForm.ccUser = []
                            secondForm.linked_tenant = order.linked_tenant
                            secondForm.linked_store = order.linked_store
                            secondForm.account_id = order.contents.account_id


                            if (res.data.ticketcc) {
                                for (var i = 0; i < res.data.ticketcc.length; i++) {
                                    var dic = res.data.ticketcc[i]
                                    secondForm.ccUser.push(dic.user_id)
                                }
                            }
                            this.$refs.secondForm.setInfo(secondForm)


                            //first
                            var firstForm = {}
                            firstForm.title = order.contents.title
                            firstForm.date = order.contents.date
                            firstForm.comments = order.contents.comments
                            firstForm.phone = order.contents.phone
                            if (reloadPhoto == true) {
                                firstForm.photos = []
                                firstForm.fileList = []
                                for (var i = 0; i < order.contents.photos.length; i++) {
                                    var uid = order.contents.photos[i]
                                    var file_id = order.contents.photos[i]
                                    var obj = {uid: uid, file_id: file_id}
                                    firstForm.photos.push(obj)

                                    this.getImgUrl(firstForm.fileList, order.contents.photos[i])
                                }
                            }
                            firstForm.account_id = order.contents.account_id
                            firstForm.key = order.contents.key
                            firstForm.service_worker = order.contents.service_worker
                            this.$refs.firstForm.setInfo(firstForm)
//                            this.pushForm.user_id = order.service_worker
                        }
//
//
                        var tableData = []
//                        this.formInfo.tenant_name = order.tenant_name
//                        this.formInfo.create_name = order.create_name
//
                        //报价单
                        if (res.data.price) {

                            for (var i = 0; i < res.data.price.length; i++) {
                                var dic = res.data.price[i]
                                var obj = {}
                                obj.quotation_name = dic.item.quotation_name
                                obj.effective_date = new Date(dic.item.effective_date).Format('yyyy-MM-dd')
                                obj.sumamount = dic.item.sumamount
                                obj.status = dic.status
                                obj.quotation_id = dic.quotation_id
                                obj.created_by = dic.created_by
                                obj.created_date = dic.created_date

                                obj.item = []

                                for (var j = 0; j < dic.item.item.length; j++) {
                                    var d = dic.item.item[j]
                                    var o = {}
                                    o.quotation_amount = d.quotation_amount
                                    o.quotation_comments = d.quotation_comments
                                    o.quotation_item = d.quotation_item
                                    o.quotation_number = d.quotation_number
                                    obj.item.push(o)
                                }

                                if (obj.status == 'QUOTATION_UNCONFIRMED') {
                                    obj.statusStr = '客户确认中'

                                } else if (obj.status == 'QUOTATION_CONFIRMED') {
                                    obj.statusStr = '报价单已确认'

                                } else if (obj.status == 'QUOTATION_REJECTED') {
                                    obj.statusStr = '报价单被退回'

                                } else {
                                    obj.statusStr = ''
                                }

                                tableData.push(obj)
                            }

                        }
                        this.$refs.fifthForm.setInfo(tableData)

                    }
                    this.loading = false

                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },

            async getUsersData() {
                var obj = this.$store.getters.getUser
                var cc_list = []
                try {
                    let data = {
                        tenant_id: obj.tenant_id
                    }

                    await http.post('/wapi/v1/getUsersData', data).then(res => {

                        if (res.success) {

                            for (var i = 0; i < res.data.length; i++) {
                                var dic = res.data[i]
                                var obj = {}
                                obj.user_id = dic.user_id
                                obj.alias = dic.alias
//                                this.secondForm.cc_list.push(obj)
                                cc_list.push(obj)
                            }
                        }
                        this.$refs.secondForm.setCCList(cc_list)

                    })
                }
                catch (err) {
                    this.error()
                }
            },

            openApprovePlaceOrder() {
                this.$confirm('是否审批下单?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.approvePlaceOrder()
//                    this.$message({
//                        type: 'success',
//                        message: '删除成功!'
//                    });
                }).catch(() => {
//                    this.$message({
//                        type: 'info',
//                        message: '已取消删除'
//                    });
                });
            },
            async approvePlaceOrder() {
                this.loading = true

                var ticket_id = this.obj.ticket_id

                try {
                    let data = {
                        ticket_id: ticket_id,
                        tenant_id:this.$store.getters.getUser.tenant_id
                    }
                    let res = await http.post('/wapi/v1/approvePlaceOrder', data)

                    if (res.success) {
                        this.init(false)
                    }
                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },

            dialogVisibles(photoUrl) {
                this.$refs.showImageDialog.show(photoUrl)
            },

            addproject() {

//                this.form3.service_item = ''
//                this.form3.comments = ''
//                this.form3.number = ''
//                this.thirdForm.dialogVisible = true
//                this.thirdForm.type = 'ADD'
                this.$refs.addThird.showDialog()

//                dialogVisible
            },

            showInfo(row) {

//                this.form3.service_item = row.service_item
//                this.form3.comments = row.comments
//                this.form3.number = row.number
//                this.thirdForm.dialogVisible = true
//                this.thirdForm.type = 'SHOW'
                this.$refs.addThird.showDialog(row)


            },
            addthirdFormItem(data) {
                this.$refs.thirdForm.addItem(data)

//                var obj = {}
//                obj.service_item = this.form3.service_item
//                this.form3.service_item = ''
//                obj.number = this.form3.number
//                this.form3.number = ''
//                obj.comments = this.form3.comments
//                this.form3.comments = ''
//                this.thirdForm.item.push(obj)
//                this.thirdForm.dialogVisible = false
            },

            async saveFirst() {

                this.loading = true
                try {

                    var info = this.$refs.firstForm.getInfo()
                    let data = {
                        contents: info,
                        ticket_id: this.obj.ticket_id,
                        tenant_id:this.$store.getters.getUser.tenant_id
                    }
                    let res = await http.post('/wapi/v1/modifyLogbookTicket', data)

                    if (res.success) {
                        this.init(true)
                    }else{
                        this.loading = true

                    }
                }
                catch (err) {
                    this.loading = false
                    this.error()
                }
            },


            async saveFoutrh() {
//                this.loading = true

                var user = this.$store.getters.getUser
                var firstInfo = this.$refs.firstForm.getInfo()
                var info = this.$refs.fourthForm.getInfo()


                var before_photos = []
                var back_photos = []
                var store_service_photos = []


                if (info.before_photos.length > 0) {
                    for (var i = 0; i < info.before_photos.length; i++) {
                        var obj = info.before_photos[i]
                        before_photos.push(obj.file_id)
                    }
                }

                if (info.back_photos.length > 0) {
                    for (var i = 0; i < info.back_photos.length; i++) {
                        var obj = info.back_photos[i]
                        back_photos.push(obj.file_id)
                    }
                }
                if (info.store_service_photos.length > 0) {
                    for (var i = 0; i < info.store_service_photos.length; i++) {
                        var obj = info.store_service_photos[i]
                        store_service_photos.push(obj.file_id)
                    }
                }
                this.loading = true


                var data = {

                    data: {
                        ticket_id: this.obj.ticket_id,
                        tenant_id: user.tenant_id,
                        created_tenant_id: info.created_tenant_id == undefined ? user.tenant_id : info.created_tenant_id,
                        created_by: info.created_by == undefined ? user.user_id : info.created_by,
                        modified_by: user.user_id,
                        created_date: info.date == undefined ? new Date().Format('YYYY-MM-DDTHH:mm:ss.SSSZ') : info.date,
                        completion_date: info.completion_date == undefined ? '' : info.completion_date,
                        receipt_status: info.receipt_status == undefined ? '' : info.receipt_status,
                        type: info.created_by == '' ? 'ADD' : 'EDIT',
                        origin: 'RETAIL',
                        submit: '',
                        service_worker: firstInfo.service_worker,
                        service_content: info.service_content == undefined ? '' : info.service_content,
                        service_describe: info.service_describe == undefined ? '' : info.service_describe,
                        store_service_content: info.store_service_content,
                        store_service_stars: info.store_service_stars,
                        before_photos: before_photos,
                        back_photos: back_photos,
                        store_service_photos: store_service_photos
                    }
                }

                let res = await http.post('/wapi/v1/saveReceipt', data)

                if (res.success) {
                    this.init(true)
                }else {
                    this.loading = false
                }
            },

            refusedTicket() {

                this.$confirm('是否拒绝此工单?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    this.setStatus('SERVICE_REFUSED')
//                    this.$message({
//                        type: 'success',
//                        message: '删除成功!'
//                    });
                }).catch(() => {
//                    this.$message({
//                        type: 'info',
//                        message: '已取消删除'
//                    });
                });
            },
            completedTicket() {

                this.$confirm('是完成此工单?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    this.setStatus('COMPLETED')
//                    this.approvePlaceOrder()
//                    this.$message({
//                        type: 'success',
//                        message: '删除成功!'
//                    });
                }).catch(() => {
//                    this.$message({
//                        type: 'info',
//                        message: '已取消删除'
//                    });
                });
            },

            async setStatus(status){
                this.loading = true

                try {
                    var user = this.$store.getters.getUser

                    let data = {
                        tenant_id: user.tenant_id,
                        status: status,
                        ticket_id: this.obj.ticket_id,
                        user_id: user.user_id,
                    }

                    let res = await http.post('/wapi/v1/setStatus', data)

                    if (res.success) {
                        this.init(false)
                    }else{
                        this.loading = true

                    }
                }
                catch (err) {
                    this.loading = true

                    this.error()
                }
            },
            //----------------------------------------------------------------------------------------------------


            async getRoles() {
                var obj = this.$store.getters.getUser
                try {
                    let data = {
                        tenant_id: obj.tenant_id,
                        user_id: obj.user_id
                    }
                    let res = await http.post('/wapi/v1/getRoles', data)

                    if (res.success) {

                        var array = res.data
                        for (var i = 0; i < array.length; i++) {
                            var dic = array[i]
                            if (dic.action_code === 'DISPATCH_SERVICE_TICKET_EMPLOYEE') {
                                //派单给自备人员		T	ACTIVE	允许在服务工单模块中派单给自备服务人员
                                this.ticketEmployee = true
                                this.getWorkData('EMPLOYEE')
                            }
                            else if (dic.action_code === 'DISPATCH_SERVICE_TICKET_OUTSOURCING') {
                                //派单给外包人员		T	ACTIVE	允许在服务工单模块中派单给外包服务人员
                                this.ticketOutsourcing = true
                                this.getWorkData('OUTSOURCING')

                            }
                            else if (dic.action_code === 'CREATE_SERVICE_TICKET') {
                                //创建工单		T	ACTIVE	允许在服务工单模块中创建新的工单
                                this.createTicket = true
                            }
                        }
                    }
                    if (this.ticketEmployee == false && this.ticketOutsourcing == true) {
                        this.pushForm.radio === '外包人员'

                    }
//                    this.getServiceWorkerData()

                }
                catch (err) {
                    this.error()
                }
            },


            async saveSecond() {


                this.loading = true
                var user = this.$store.getters.getUser
                try {


                    var paramStr = "client_id" + user.client_id
                        + "&client_secret=" + user.client_secret
                        + "&service_id=" + user.service_id
                        + "&username=" + user.username
                        + "&tenant_id=" + user.tenant_id
                        + "&token=" + user.token
                        + "&data={"
                        + "\"tenant_id\":\"" + user.tenant_id + "\","
                        + "\"comments\":\"" + this.secondForm.comments + "\","
                        + "\"service_worker\":\"" + this.pushForm.user_id + "\","
                        + "\"count_down\":\"" + 60 + "\","
                        + "\"contents\":"
                        + "{"
                        + "\"title\":\"" + this.firstForm.title + "\","
                        + "\"comments\":\"" + this.firstForm.comments + "\","
                        + "\"date\":\"" + this.firstForm.date + "\","
                        + "\"phone\":\"" + this.firstForm.phone + "\","
                        + "\"key\":\"" + this.firstForm.key + "\","
                        + "\"photos\":[";
                    if (this.firstForm.photos.length > 0) {
                        for (var i = 0; i < this.firstForm.photos.length; i++) {
                            var obj = this.firstForm.photos[i]
                            if (i == 0) {
                                paramStr = paramStr + "\"" + obj.file_id + "\"";
                            } else {
                                paramStr = paramStr + ",\"" + obj.file_id + "\"";
                            }

                        }
                    }
                    paramStr = paramStr + "],"
                        + "\"account_id\":\"" + this.firstForm.account_id + "\""
                        + "},   "
                        + "\"cc_list\":["

                    if (this.secondForm.ccUser) {
                        for (var i = 0; i < this.secondForm.ccUser.length; i++) {
                            var user_id = this.secondForm.ccUser[i]
                            if (i == 0) {
                                paramStr = paramStr + "{\"tenant_id\":\"" + user.tenant_id + "\", \"user_id\":\"" + user_id + "\"} ";
                            }
                            else {
                                paramStr = paramStr + ", {\"tenant_id\":\"" + user.tenant_id + "\", \"user_id\":\"" + user_id + "\"} ";
                            }

                        }
                    }

                    paramStr = paramStr + "], " + "\"modified_by\":\"" + user.user_id + "\","
                        + "\"ticket_id\":\"" + this.obj.ticket_id + "\""
                        + "}";


                    await http.post('https://api.concierge24x7.cn:16079/wapi/order/modifyOrde', paramStr).then(res => {


                        if (res.success) {
                            this.init(false)

                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                        }
                        else {
                            this.$message.error(res.message);
                        }
                        this.loading = false
                    })


                }
                catch (err) {
                    this.error()
                }
            },

            async saveThird() {


                this.loading = true
                var user = this.$store.getters.getUser
                try {


                    var created_by = user.user_id
                    var type = 'ADD'
                    if (this.thirdForm.created_by != '') {
                        created_by = this.thirdForm.created_by
                        type = 'EDIT'
                    }

                    var paramStr = "client_id" + user.client_id
                        + "&client_secret=" + user.client_secret
                        + "&service_id=" + user.service_id
                        + "&username=" + user.username
                        + "&tenant_id=" + user.tenant_id
                        + "&token=" + user.token
                        + "&data={"
                        + "\"ticket_id\":\"" + this.obj.ticket_id + "\","
                        + "\"created_by\":\"" + created_by + "\","
                        + "\"modified_by\":\"" + user.user_id + "\","
                        + "\"tenant_id\":\"" + user.tenant_id + "\","
                        + "\"user_id\":\"" + user.user_id + "\","
                        + "\"date\":\"" + this.thirdForm.date + "\","
                        + "\"type\":\"" + type + "\","
                        + "\"submit\":\"" + '' + "\","
                        + "\"service_worker\":\"" + this.pushForm.user_id + "\","
                        + "\"service_comments\":\"" + this.thirdForm.service_comments + "\","
                        + "\"photos\":[";


                    if (this.thirdForm.photos.length > 0) {
                        for (var i = 0; i < this.thirdForm.photos.length; i++) {
                            var file_id = this.thirdForm.photos[i].file_id
                            if (i == 0) {
                                paramStr = paramStr + "\"" + file_id + "\"";
                            } else {
                                paramStr = paramStr + ",\"" + file_id + "\"";
                            }

                        }
                    }
                    paramStr = paramStr + "],"

                        + "\"item\":[";
                    if (this.thirdForm.item.length > 0) {
                        for (var i = 0; i < this.thirdForm.item.length; i++) {
                            var dic = this.thirdForm.item[i]
                            if (i == 0) {
                                paramStr = paramStr + " {\"service_item\": \"" + dic.service_item + "\", " +
                                    "\"number\" : \"" + dic.number + "\", \"comments\":\"" + dic.comments + "\"} ";
                            } else {
                                paramStr = paramStr + " , {\"service_item\": \"" + dic.service_item + "\", " +
                                    "\"number\" : \"" + dic.number + "\", \"comments\":\"" + dic.comments + "\"} ";
                            }
                        }
                    }
                    paramStr = paramStr + "]"
                    paramStr = paramStr + "}"


                    await http.post('https://api.concierge24x7.cn:16080/wapi/order/saveServiceList', paramStr).then(res => {


                        if (res.success) {
                            this.init(false)

                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                        }
                        else {
                            this.$message.error(res.message);
                        }
                        this.loading = false
                    })


                }
                catch (err) {
                    this.error()
                }
            },


            addPrice() {

                this.formInfo.quotation_name = ""
                this.formInfo.effective_date = ""
                this.formInfo.tableData = []
                this.formInfo.sumamount = ""
                this.formInfo.quotation_id = ""


                this.formInfo.date = new Date().Format('yyyy-MM-dd') /// moment(new Date()).format("yyyy-MM-dd")
                this.info = false


            },
            saveForm4Info() {
                var obj = {}
                obj.quotation_comments = this.form4.quotation_comments
                obj.quotation_number = this.form4.quotation_number
                obj.quotation_amount = this.form4.quotation_amount
                obj.quotation_item = this.form4.quotation_item
                this.formInfo.tableData.push(obj)
                this.form4.info = false

                var sumamount = 0
                for (var i = 0; i < this.formInfo.tableData.length; i++) {
                    var dic = this.formInfo.tableData[i]
                    sumamount += dic.quotation_amount * 1
                }
                this.formInfo.sumamount = sumamount
            },
            async saveFifth() {




                this.loading = true
                var user = this.$store.getters.getUser
                try {

                    var quotation_id = ''
                    var created_by = user.user_id
                    var created_date = new Date().Format('yyyy-MM-dd')
                    var type = 'ADD'
                    if (this.formInfo.quotation_id != '') {
                        created_by = this.formInfo.created_by
                        type = 'EDIT'
                        created_date = this.formInfo.created_date
                        quotation_id = this.formInfo.quotation_id
                    }


                    var paramStr = "client_id=" + user.client_id
                        + "&client_secret=" + user.client_secret
                        + "&service_id=" + user.service_id
                        + "&username=" + user.username
                        + "&tenant_id=" + user.tenant_id
                        + "&token=" + user.token
                        + "&data={"
                        + "\"effective_date\":\"" + new Date(this.formInfo.effective_date).Format('yyyy-MM-dd') + "\","
                        + "\"sumamount\":\"" + this.formInfo.sumamount + "\","
                        + "\"quotation_status\":\"" + this.formInfo.quotation_status + "\","
                        + "\"quotation_name\":\"" + this.formInfo.quotation_name + "\","
                        + "\"quotation_id\":\"" + quotation_id + "\","
                        + "\"ticket_id\":\"" + this.obj.ticket_id + "\","
                        + "\"tenant_id\":\"" + user.tenant_id + "\","
                        + "\"user_id\":\"" + user.user_id + "\","
                        + "\"created_by\":\"" + created_by + "\","
                        + "\"modified_by\":\"" + user.user_id + "\","
                        + "\"created_date\":\"" + created_date + "\","
                        + "\"type\":\"" + type + "\","
                        + "\"submit\":\"" + "" + "\", "
                        + "\"item\":[";


                    if (this.formInfo.tableData.length > 0) {
                        for (var i = 0; i < this.formInfo.tableData.length; i++) {
                            var dic = this.formInfo.tableData[i]
                            if (i == 0) {
                                paramStr = paramStr + " {\"quotation_comments\": \"" + dic.quotation_comments + "\", " +
                                    "\"quotation_number\" : \"" + dic.quotation_number + "\", " +
                                    "\"quotation_amount\" : \"" + dic.quotation_amount + "\", " +
                                    "\"quotation_item\":\"" + dic.quotation_item + "\"} ";
                            } else {
                                paramStr = paramStr + ", {\"quotation_comments\": \"" + dic.quotation_comments + "\", " +
                                    "\"quotation_number\" : \"" + dic.quotation_number + "\", " +
                                    "\"quotation_amount\" : \"" + dic.quotation_amount + "\", " +
                                    "\"quotation_item\":\"" + dic.quotation_item + "\"} ";
                            }
                        }
                    }
                    paramStr = paramStr + "]"

                    paramStr = paramStr + "}"


                    await http.post('https://api.concierge24x7.cn:16080/wapi/order/saveQuotation', paramStr).then(res => {


                        if (res.success) {
                            this.init(false)

                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                        }
                        else {
                            this.$message.error(res.message);
                        }
                        this.info = false
                        this.loading = false
                    })


                }
                catch (err) {
                    this.error()
                }
            },

            async enterPushForm() {

                this.pushForm.user_id = this.pushForm.tempUserId
                this.pushForm.push = false


                this.loading = true
                var user = this.$store.getters.getUser
                try {


                    var paramStr = "client_id" + user.client_id
                        + "&client_secret=" + user.client_secret
                        + "&service_id=" + user.service_id
                        + "&username=" + user.username
                        + "&tenant_id=" + user.tenant_id
                        + "&token=" + user.token
                        + "&data={"
                        + "\"tenant_id\":\"" + user.tenant_id + "\","
                        + "\"comments\":\"" + this.secondForm.comments + "\","
                        + "\"service_worker\":\"" + this.pushForm.user_id + "\","
                        + "\"count_down\":\"" + 60 + "\","
                        + "\"contents\":"
                        + "{"
                        + "\"title\":\"" + this.firstForm.title + "\","
                        + "\"comments\":\"" + this.firstForm.comments + "\","
                        + "\"date\":\"" + this.firstForm.date + "\","
                        + "\"phone\":\"" + this.firstForm.phone + "\","
                        + "\"key\":\"" + this.firstForm.key + "\","
                        + "\"photos\":[";
                    if (this.firstForm.photos.length > 0) {
                        for (var i = 0; i < this.firstForm.photos.length; i++) {
                            var obj = this.firstForm.photos[i]
                            if (i == 0) {
                                paramStr = paramStr + "\"" + obj.file_id + "\"";
                            } else {
                                paramStr = paramStr + ",\"" + obj.file_id + "\"";
                            }

                        }
                    }
                    paramStr = paramStr + "],"
                        + "\"account_id\":\"" + this.firstForm.account_id + "\""
                        + "},   "
                        + "\"cc_list\":["

                    if (this.secondForm.ccUser) {
                        for (var i = 0; i < this.secondForm.ccUser.length; i++) {
                            var user_id = this.secondForm.ccUser[i]
                            if (i == 0) {
                                paramStr = paramStr + "{\"tenant_id\":\"" + user.tenant_id + "\", \"user_id\":\"" + user_id + "\"} ";
                            }
                            else {
                                paramStr = paramStr + ", {\"tenant_id\":\"" + user.tenant_id + "\", \"user_id\":\"" + user_id + "\"} ";
                            }

                        }
                    }

                    paramStr = paramStr + "], " + "\"modified_by\":\"" + user.user_id + "\","
                        + "\"ticket_id\":\"" + this.obj.ticket_id + "\""
                        + "}";


                    await http.post('https://api.concierge24x7.cn:16079/wapi/order/modifyOrde', paramStr).then(res => {


                        if (res.success) {
                            this.init(false)

                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                        }
                        else {
                            this.$message.error(res.message);
                        }
                        this.loading = false
                    })


                }
                catch (err) {
                    this.error()
                }
            },

            closePushForm() {

                this.pushForm.tempUserId = this.pushForm.user_id
                this.pushForm.push = false
            },
            showPushForm() {

                this.pushForm.push = true
                this.pushForm.tempUserId = this.pushForm.user_id
            },

            async enterClose(status) {
                try {
                    var user = this.$store.getters.getUser

                    var paramStr = "client_id=" + user.client_id
                        + "&client_secret=" + user.client_secret
                        + "&service_id=" + user.service_id
                        + "&username=" + user.username
                        + "&tenant_id=" + user.tenant_id
                        + "&token=" + user.token
                        + "&data={"
                        + "\"tenant_id\":\"" + user.tenant_id + "\","
                        + "\"status\":\"" + status + "\","
                        + "\"modified_by\":\"" + user.user_id + "\","
                        + "\"ticket_id\":\"" + this.obj.ticket_id + "\"}"


                    await http.post('https://api.concierge24x7.cn:16080/wapi/order/setStatus', paramStr).then(res => {


                        if (res.success) {
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            this.init(false)

                        }
                        else {
                            this.$message.error(res.message);
                        }
                        this.loading = false
                        this.showCloseTicket = false;
                        this.showCompletedTicket = false;
                        this.showServiceRefused = false;

                    })
                }
                catch (err) {
                    this.error()
                }
            },

            closeTicket() {

                this.showCloseTicket = true;
            },
            clickImage(user_id) {
                if (this.pushForm.tempUserId != user_id) {
                    this.pushForm.tempUserId = user_id
                }
            },

            async getWorkData(type) {
                var user = this.$store.getters.getUser

                try {
                    var paramStr = "client_id=" + user.client_id
                        + "&client_secret=" + user.client_secret
                        + "&service_id=" + user.service_id
                        + "&username=" + user.username
                        + "&tenant_id=" + user.tenant_id
                        + "&token=" + user.token
                        + "&data={"
                        + "\"tenant_id\":\"" + user.tenant_id + "\","
                        + "\"city_id\":[],"
                        + "\"offset\":\"0\","
                        + "\"last_name\":\"\","
                        + "\"type\":\"" + type + "\"}"


//                    var paramStr = {
//                        client_id : user.client_id,
//                        client_secret : user.client_secret,
//                        service_id : user.service_id,
//                        username : user.username,
//                        tenant_id : user.tenant_id,
//                        token : user.token,
//                        data : {
//                            tenant_id : user.tenant_id,
//                            city_id : [],
//                            offset : 0,
//                            last_name : '',
//                            type : type
//                        }
//                    }


                    await http.post('https://api.concierge24x7.cn:16080/wapi/service/getServiceWorkerByType', paramStr).then(res => {


                        if (res.success) {
                            var array = res.data.worker_info

                            if (type == 'EMPLOYEE') {
                                this.pushForm.EMPLOYEE = array
                            }
                            if (type == 'OUTSOURCING') {
                                this.pushForm.OUTSOURCING = array
                            }
//                            for (var i = 0; i < array.length; i++){
//                                var dd = array[i]
//                                var oo = {}
//
//                                if (type == 'EMPLOYEE'){
//                                    this.pushForm.EMPLOYEE.push(oo)
//                                }
//                                if (type == 'OUTSOURCING'){
//                                    this.pushForm.OUTSOURCING.push(oo)
//                                }
//                            }
                        }
                        else {
                            this.$message.error(res.message);
                        }
                        this.loading = false
                    })
                }
                catch (err) {
                    this.error()
                }
            },

            onClick1() {
                if (this.form.radio !== '服务进度') {
                    this.form.radio = '服务进度'
                }
            },
            onClick2() {
                if (this.form.radio !== '与门店的沟通') {
                    this.form.radio = '与门店的沟通'
                }
            },
            onClick3() {
                if (this.form.radio !== '与服务人员的沟通') {
                    this.form.radio = '与服务人员的沟通'
                }
            },

            onClick10() {
                if (this.pushForm.radio !== '自备人员') {
                    this.pushForm.radio = '自备人员'
                }
            },
            onClick20() {
                if (this.pushForm.radio !== '外包人员') {
                    this.pushForm.radio = '外包人员'
                }
            },


            addFifthItem(index, row) {

                this.form4.quotation_comments = ""
                this.form4.quotation_number = ""
                this.form4.quotation_amount = ""
                this.form4.quotation_item = ""
                this.form4.info = true

            },
            showFifthItemInfo(index, row) {

                this.form4.quotation_comments = row.quotation_comments
                this.form4.quotation_number = row.quotation_number
                this.form4.quotation_amount = row.quotation_amount
                this.form4.quotation_item = row.quotation_item
                this.form4.info = true


            },
            showFifthInfo(row) {




                this.fifthInfo.setInfo(row)
                this.info = false
            },
            backFifthForm() {
                this.info = true
            },


            handleClick(tab, event) {
//                this.activeName = tab.name
                this.$store.commit('setRadio2', {'radio' : tab.name})


            },
            handleClose(done) {
                // this.$confirm('确认关闭？')
                //     .then(_ => {
                //         done();
                //     })
                //     .catch(_ => {});
                done();
                // this.$forceUpdate()
            },
            back() {
                this.$router.push({
                    path: '/serviceWorkOrder',
                })


            },


        }

    }
</script>
<style lang="scss" module >
    @import '../../assets/css/default';

    .container {
        .wrapper {
            overflow: auto;
            background: #fff;
            .top {
                .wrap {
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: nowrap;
                }
                .font {
                    font-size: $fontSize;
                    color: #3b3b3e;
                    text-align: left;
                }
            }
            .border {
                border-bottom: 2px dashed #e7eaec;
                padding: 0px;
            }

        }

    }
</style>


<style>

    .scrollbar {
        border: 1px solid #dedede;
        margin-top: 5px;
        height: 550px;
    }

    .el-aside {
        background-color: #E9EEF3;
        color: #333;
    }

    .el-main {
        background-color: #ffffff;

    }


</style>


<style type="text/css" scoped>
    * {
        margin: 0;
        padding: 0;
    }

    .t-ctn {
        width: 100%;
        overflow-x: auto;
    }

    .t-ctn .s-ctn {
        height: 20px;
        white-space: nowrap;
        font-size: 0;
    }

    .t-ctn .s-ctn div {
        font-size: 14px;
        box-sizing: border-box;
        white-space: normal;
        word-wrap: break-word;
        word-break: break-all;
        overflow: hidden;
        display: inline-block;
        width: 200px;
        height: 100%;
        border: 10px

    }
</style>



// WEBPACK FOOTER //
// src/pages/serviceWorkOrder/info.vue